<obg-m-dialog-layout #dialog dialogId="sga-session-limit" [hideFooter]="true">
	<obg-m-sga-session-limit-container
		(navigate)="onNavigate()"
		autoFocusDisabled
		collapseDepositInfo
		navigateToReturnUrl
	>
	</obg-m-sga-session-limit-container>
</obg-m-dialog-layout>
